import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Input,
  Select,
  Stack,
  Text,
  Textarea,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Heading,
  Box,
  Image,
  Spinner,
  Checkbox,
} from "@chakra-ui/react";

const DeleteGroupMessageModal = ({ isOpen, onClose, authUserId, chat, groupData, setIsDeleted, handleGroupMessageDelete }) => {
  //sconsole.log("userid-->", authUserId);

  const [allFollowers, setAllFollowers] = useState([]); //unused
  const [loading, setLoading] = useState(false); //unused
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedSingleUser, setSelectedSingleUser] = useState([]);

  const containerBgColor = useColorModeValue("#fff", "#000216");
  const inputBgColor = useColorModeValue("#F9FAFC", "rgba(6, 119, 232, 0.2)"); 

  const inputStyles = {
    p: "5px",
    borderRadius: "5px",
    boxShadow: "3px 8px 13px 0px #8080800f",
    bg: inputBgColor,
    color: "rgba(6, 119, 232, 1)",
    w: "15%",
    //color: "#697C94",
    // h: "2em"
  };

  const btnStyle = {
    p: "5px 10px",
    alignItems: "center",
    borderRadius: "5px",
    color: "#fff",
    direction: "row",
    cursor: "pointer",
    w: "30%",
  };

  const gotoDeleteGroup = async (selectedChat, selectedGroupData) => {
    //console.log(groupData);
    setLoading(true)
    await handleGroupMessageDelete(selectedChat, selectedGroupData)
    setIsDeleted(true)
    onClose(true)
  }

  return (
    <>
    
    <Modal isOpen={isOpen} onClose={onClose} size="lg" scrollBehavior="inside">
      
        <ModalOverlay />
        <ModalContent bg={containerBgColor}>
          <ModalHeader>
            
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
          <Flex justifyContent="center" alignItems="center" mb={"2em"}>
            <Box fontSize={"1.0em"} textAlign={"center"}>
              <Text>Are you sure you want to delete this message from</Text>
              <Text>{groupData?.name}</Text>
            </Box>
          </Flex>
          
          <Flex justifyContent="center" alignItems="center" mb={"2em"}>
          <Box fontSize={"1.0em"} textAlign={"center"}>
            <Text>Please note that once this action is taken,</Text>
            <Text>cannot be recovered</Text>
          </Box>
          </Flex>

          <Flex justifyContent="space-between" alignItems="center" mb={"1em"}>
          <Box fontSize={"1.0em"}>
            <Button fontSize={"1.0em"} w={200} bg={"red"}
            
            onClick={() => gotoDeleteGroup(chat, groupData)}
            >Delete </Button>
          </Box>

          <Box fontSize={"1.0em"} textAlign={"center"}>
            <Button fontSize={"1.0em"} w={200} bg={"#020B19"}
            onClick={() => onClose(true)}
            >Cancel </Button>
          </Box>
          </Flex>

          </ModalBody>
        </ModalContent>
    </Modal>
    
    </>
  )
}

export default DeleteGroupMessageModal